import styles from './PageHeader.module.scss';
import SearchBox from '@customer/components/inputs/search-box/SearchBox';
import FilterButton from '@customer/components/inputs/filter-button/FilterButton';
import FilterSummary, {
  FilterSummaryProps,
} from '@customer/components/inputs/filter-summary/FilterSummary';
import RefreshButton from '@customer/components/inputs/refresh-button/RefreshButton';
import { ReactElement } from 'react';
import { TagDescription } from '@reduxjs/toolkit/query';
import { QueryTag } from '@customer/store/api';

interface PageHeaderProps {
  title: string;
  sliceKey: string;
  tagsToClearOnRefresh: TagDescription<QueryTag>[];
  filterProps: FilterSummaryProps;
  hideFilter?: boolean;
  actions?: ReactElement | null;
}

export function PageHeader({
  title,
  sliceKey,
  tagsToClearOnRefresh,
  filterProps,
  hideFilter,
  actions,
}: PageHeaderProps): ReactElement {
  return (
    <div className={styles.header}>
      <div className={styles.title}>
        <div>{title}</div>
        <RefreshButton tagsToClear={tagsToClearOnRefresh} />
      </div>
      <div className={styles.actionBar}>
        <FilterSummary {...filterProps} />
        <div className={`${styles.actions} ${hideFilter ? styles['actions--noFilter'] : ''}`}>
          {actions}
          {!hideFilter && <FilterButton filters={filterProps.filterGroup} disabled={false} />}
          <div className={styles.actions__search}>
            <SearchBox sliceKey={sliceKey} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageHeader;
